import React from "react";
import Img from "gatsby-image";

export default ({ data }) => {
  return <header className="header" id="header" />;
};



// WEBPACK FOOTER //
// ./src/components/header.js